module.exports = __webpack_public_path__ + "img/cattunnel23.db4c7510.jpg";